import React, { useState, useEffect } from "react";
import Header from "./Header";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { VscEyeClosed } from "react-icons/vsc";
import { RxEyeOpen } from "react-icons/rx";
import { FaCamera, FaUpload, FaUser, FaEnvelope, FaLock, FaPhone, FaGlobe, FaMapMarkerAlt } from "react-icons/fa";
import ButtonWithLoader from '../CommonComponents/ButtonWithLoader';
import { currentIpAddressDetails } from "../CommonMethod/CommonMethods";
import { CitySelect, CountrySelect, StateSelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import 'react-phone-input-2/lib/style.css';
import "react-toastify/dist/ReactToastify.css";
import './PartnerSignup.css';
import Defaultloadinggif from "../../layout/Others/Defaultloadinggif";
import { getItemToken } from "../../Utils/localStorageUtils";

const PartnerSignup = () => {

    const access_token = localStorage.getItem("access_token");
    const headers = {
        "Content-Type": "application/json", Authorization: "Bearer " + access_token,
        Accept: "application/json", "Access-Control-Allow-Origin": "*",
    };
    const [inputField, setInputField] = useState({
        username: "", last_name: "", email: "", gender: "", ccode: "", mobile: "",
        password: "", password_confirm: "", city: "", state: "", country: "",
    });

    const [errField, setErrField] = useState({
        usernameerr: "", last_nameerr: "", emailerr: "", passworderr: "",
        ccodeerror: "", mobileerror: "", password_confirmerror: "",
        countryerr: "", stateerr: "", cityerr: ""
    });
    const [phoneNumber, setPhoneNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const prevLocation = localStorage.getItem('location');
    const [ipDetails, setIpDetails] = useState(null)
    const [countryid, setCountryid] = useState(0);
    const [stateid, setstateid] = useState(0);
    const [cityid, setCityid] = useState(0);
    const [partnerSettings, setPartnerSettings] = useState()
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [details, setDetails] = useState({
        light_mode_logo: null,
    });

    const handleWorld = (name, value) => {
        setInputField({ ...inputField, [name]: value });
    }

    function handleChange(e) {
        setInputField({ ...inputField, [e.target.name]: e.target.value });
    }
    const handleGenderChange = (e) => {
        setInputField({
            ...inputField,
            gender: e.target.value, // Update gender in the state
        });
    };

    const [passwordType, setPasswordType] = useState("password");
    const [confirmPasswordType, setConfirmPasswordType] = useState("password");

    const togglePassword = () => {
        setPasswordType((prevType) => (prevType === "password" ? "text" : "password"));
    };

    const toggleConfirmPassword = () => {
        setConfirmPasswordType((prevType) => (prevType === "password" ? "text" : "password"));
    };

    const handleOnChange = (value, country) => {
        setPhoneNumber(value);
        setInputField({
            ...inputField,
            ccode: country.dialCode,
            mobile: value.slice(country.dialCode.length),
        });
    };
    useEffect(() => {
        async function fetchIpDetails() {
            try {
                const data = await currentIpAddressDetails; // Resolve the promise
                if (data) {
                    setIpDetails(data);
                    // console.log('IP Address Details:', data);
                } else {
                    console.log('Failed to retrieve IP address details.');
                }
            } catch (error) {
                console.error('Error retrieving IP address details:', error);
            }
        }

        fetchIpDetails();
    }, []);



    const fetchSignupMenu = async () => {
        try {
            const accessToken = getItemToken('access_token');

            const headers = accessToken
                ? {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                }
                : {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                };

            const response = await axios.get(
                `${process.env.REACT_APP_Baseurl}/Front-end/Partner-Signup-Menu`,
                { headers }
            );

            const result = response?.data?.PartnerSignupMenu;
            setPartnerSettings(result);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching signup menu:", error);
            setLoading(false);
        }
    };



    // const fetchSignupMenu = () => {
    //     axios
    //         .get(
    //             `${process.env.REACT_APP_Baseurl}/Front-end/Partner-Signup-Menu`,
    //             { headers: headers }
    //         )
    //         .then((response) => {
    //             var result = response?.data?.PartnerSignupMenu;
    //             setPartnerSettings(result);
    //             setLoading(false);
    //         })
    //         .catch((error) => {
    //             setLoading(false);
    //         });
    // };
    useEffect(() => {
        fetchSignupMenu();
    }, []);

    // console.log(partnerSettings, "partnerSettings");

    const formData = {
        username: inputField?.username,
        last_name: inputField?.last_name,
        slug: inputField?.username,
        email: inputField.email,
        gender: inputField?.gender,
        ccode: inputField.ccode,
        mobile: phoneNumber,
        password: inputField.password,
        password_confirm: inputField?.password_confirm,
        city: inputField?.city,
        state: inputField?.state,
        country: inputField?.country,
        status: 0
    };
    async function signup() {
        try {
            // console.log('Starting partner signup process...');
            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/partner/signup`, formData, { headers });
            const result = response?.data;
            // console.log('Signup response:', result);

            if (result?.status) {
                const PartnerUserID = response?.data?.PartnerUserID;
                const UserID = response?.data?.UserID;
                // console.log('Partner created successfully. IDs:', { PartnerUserID, UserID });

                // Only upload profile image if it exists
                if (profileImage && PartnerUserID && UserID) {
                    try {
                        // console.log('Uploading profile image...');
                        const profileImageData = new FormData();
                        profileImageData.append("avatar", profileImage);
                        profileImageData.append("PartnerUserID", PartnerUserID);
                        profileImageData.append("UserID", UserID);
                        const profileResponse = await axios.post(`${process.env.REACT_APP_Baseurl}/partner/uploadProfileImage`, profileImageData);
                        // console.log('Profile image upload response:', profileResponse?.data);
                    } catch (imageError) {
                        console.warn('Profile image upload failed, but signup was successful:', imageError?.response?.data?.message || imageError?.message);
                        // Don't fail the entire signup if image upload fails
                    }
                }

                toast.success(t(result?.message) || 'Partner signup successful!');
                // console.log('Navigating to partner...');
                // Use setTimeout to ensure state updates are complete before navigation
                setTimeout(() => {
                    navigate('/partner');
                }, 1000);
            } else {
                const errorMsg = result?.message || 'Signup failed';
                toast.error(t(errorMsg));
                console.error('Signup failed:', errorMsg);
            }

            setLoading(false);

        } catch (error) {
            console.error('Signup error:', error);
            const errorMessage = error?.response?.data?.message || error?.message || "Something went wrong. Please try again.";
            toast.error(t(errorMessage));
            setLoading(false);
        }
    }

    const validateForm = (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);

        const validateEmail = (email) =>
            String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

        // Reset all error fields
        setErrField({
            usernameerr: "",
            last_nameerr: "",
            emailerr: "",
            passworderr: "",
            ccodeerror: "",
            mobileerror: "",
            password_confirmerror: "",
            countryerr: "",
            stateerr: "",
            cityerr: ""
        });

        let formIsValid = true;
        let errors = {};

        // Validate Name (if enabled)
        if (partnerSettings?.username !== 0) {
            if (!inputField?.username || inputField.username.trim() === "") {
                formIsValid = false;
                errors.usernameerr = "Please Enter First Name*";
            } else if (inputField.username.trim().length < 2) {
                formIsValid = false;
                errors.usernameerr = "First Name must be at least 2 characters*";
            }
        }

        // Validate Last Name (if enabled) - assuming same conditions as first name
        if (partnerSettings?.username !== 0) {
            if (!inputField?.last_name || inputField.last_name.trim() === "") {
                formIsValid = false;
                errors.last_nameerr = "Please Enter Last Name*";
            } else if (inputField.last_name.trim().length < 2) {
                formIsValid = false;
                errors.last_nameerr = "Last Name must be at least 2 characters*";
            }
        }

        // Validate Email (if enabled)
        if (partnerSettings?.email !== 0) {
            if (!inputField?.email || inputField.email.trim() === "") {
                formIsValid = false;
                errors.emailerr = "Please Enter Email*";
            } else if (!validateEmail(inputField?.email)) {
                formIsValid = false;
                errors.emailerr = "Please Enter Valid Email ID*";
            }
        }

        // Validate Mobile Number (if enabled)
        if (partnerSettings?.mobile !== 0) {
            if (!phoneNumber || phoneNumber.trim() === "") {
                formIsValid = false;
                errors.mobileerror = "Please Enter Mobile Number*";
            } else if (!inputField?.ccode || inputField.ccode === "") {
                formIsValid = false;
                errors.mobileerror = "Please Select Country Code*";
            } else if (!inputField?.mobile || inputField.mobile.trim().length < 6) {
                formIsValid = false;
                errors.mobileerror = "Please Enter Valid Mobile Number*";
            }
        }

        // Validate Password (if enabled)
        if (partnerSettings?.password !== 0) {
            if (!inputField?.password || inputField.password.trim() === "") {
                formIsValid = false;
                errors.passworderr = "Please Enter Password*";
            } else if (inputField.password.length < 6) {
                formIsValid = false;
                errors.passworderr = "Password must be at least 6 characters*";
            }
        }

        // Validate Confirm Password (if enabled)
        if (partnerSettings?.password_confirm !== 0) {
            if (!inputField?.password_confirm || inputField.password_confirm.trim() === "") {
                formIsValid = false;
                errors.password_confirmerror = "Please Enter Confirm Password*";
            } else if (inputField.password !== inputField.password_confirm) {
                formIsValid = false;
                errors.password_confirmerror = "Passwords do not match*";
            }
        }

        // // Validate Country (if enabled)
        // if (partnerSettings?.country !== 0) {
        //     if (!inputField?.country || inputField.country.trim() === "") {
        //         formIsValid = false;
        //         errors.countryerr = "Please Select Country*";
        //     }
        // }

        // // Validate State (if enabled and country is selected)
        // if (partnerSettings?.state !== 0 && inputField?.country) {
        //     if (!inputField?.state || inputField.state.trim() === "") {
        //         formIsValid = false;
        //         errors.stateerr = "Please Select State*";
        //     }
        // }

        // // Validate City (if enabled and state is selected)
        // if (partnerSettings?.city !== 0 && inputField?.state) {
        //     if (!inputField?.city || inputField.city.trim() === "") {
        //         formIsValid = false;
        //         errors.cityerr = "Please Select City*";
        //     }
        // }

        // Set all errors at once
        if (!formIsValid) {
            setErrField((prev) => ({ ...prev, ...errors }));
            setLoading(false);
            return false;
        }

        // If validation passes, call signup
        if (formIsValid) {
            signup();
        }
        return formIsValid;
    };
    const [profileImage, setProfileImage] = useState(null)

    const handleCoverImageChange = async (event, errorKey) => {
        const selectedFile = event.target.files[0];
        // console.log(selectedFile, 'selectedfile')
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = () => {
                setProfileImage(selectedFile);
            };
            reader.readAsDataURL(selectedFile);

        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const body = {
                Login_user_type: 9,
                Login_user_id: null,  // You can keep null if API accepts it, or use "" if necessary
                Login_device_type: "web"
            };

            try {
                const reqData = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Header-index`, body, {
                    headers: {
                        'guestverfiykey': "WebVodWebnexs",
                        'Content-Type': 'application/json'
                    }
                });
                setDetails(reqData?.data?.admin_theme_mode_details);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);





    return (
        <div>
            {/* <Header /> */}
            <form onSubmit={validateForm}>
                <section className="signup h-100 p-4">
                    <div className="container">
                        <div className="d-flex justify-content-center text-center">
                            <div className="box-signin-partner p-4 rounded-3 shadow">



                                <div className="mt-2 text-center">
                                    {details?.light_mode_logo === null ? (<Defaultloadinggif ></Defaultloadinggif>)
                                        : (<img src={details?.light_mode_logo} alt="SignInLogo" className="d-block mx-auto signin-logo-images w-50 object-fit-contain" />)}
                                </div>

                                <h4 className="text-center mt-2">Partner SignUp</h4>

                                {/* Partner-Avatar or Profile Image */}
                                {/* <div>
                                    {partnerSettings?.avatar !== 0 ? (
                                        <div className='position-relative profileImageUpdateMultiPartner mx-auto border border-2 theme-border-color rounded-circle p-1 mt-2 mb-2'>
                                            <div
                                                key={'logo'}
                                                style={{
                                                    backgroundImage: `url(${profileImage ? URL.createObjectURL(profileImage) : ''})`,
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundSize: 'cover',
                                                    width: "100%",
                                                    height: "90px"
                                                }}
                                                className="rounded-circle profileImageUpdateMultiImage"
                                            >
                                                <span className='profileImageLens position-absolute theme-bg-color-secondary p-2 rounded-circle d-flex align-items-center justify-content-center'>
                                                    <FaCamera style={{ width: "16px", height: "16px" }} />
                                                </span>
                                                <input
                                                    type="file"
                                                    onChange={(event) => handleCoverImageChange(event)}
                                                    className='profileInput w-100 h-100 position-absolute'
                                                    accept='image/*'
                                                />
                                                <FaUpload
                                                    style={{
                                                        width: "20px",
                                                        height: "20px",
                                                        display: profileImage ? 'none' : 'block',
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        color: '#666666',
                                                        zIndex: 2
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ) : ""}

                                </div> */}
                                {/* Partner First Name */}
                                {partnerSettings?.username !== 0 && (
                                    <div className="mb-4">
                                        <label className="input-label text-start text-start">First Name</label>
                                        <div className="position-relative">
                                            <FaUser style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#666666', zIndex: 2 }} />
                                            <input
                                                className="w-100"
                                                style={{ paddingLeft: '48px' }}
                                                id="username"
                                                type="text"
                                                name="username"
                                                value={inputField?.username}
                                                placeholder="Enter First Name"
                                                autoComplete="off"
                                                onChange={handleChange}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        validateForm(e);
                                                    }
                                                }}
                                            />
                                        </div>
                                        {errField?.usernameerr !== "" && (
                                            <span className="d-flex text-danger signin-error mt-1">
                                                {errField?.usernameerr}
                                            </span>
                                        )}
                                    </div>
                                )}

                                {/* Partner Last Name */}
                                {partnerSettings?.username !== 0 && (
                                    <div className="mb-4">
                                        <label className="input-label text-start text-start">Last Name</label>
                                        <div className="position-relative">
                                            <FaUser style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#666666', zIndex: 2 }} />
                                            <input
                                                className="w-100"
                                                style={{ paddingLeft: '48px' }}
                                                id="last_name"
                                                type="text"
                                                name="last_name"
                                                value={inputField?.last_name}
                                                placeholder="Enter Last Name"
                                                autoComplete="off"
                                                onChange={handleChange}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        validateForm(e);
                                                    }
                                                }}
                                            />
                                        </div>
                                        {errField?.last_nameerr !== "" && (
                                            <span className="d-flex text-danger signin-error mt-1">
                                                {errField?.last_nameerr}
                                            </span>
                                        )}
                                    </div>
                                )}

                                {/* Email */}
                                {partnerSettings?.email !== 0 && (
                                    <div className="mb-4">
                                        <label className="input-label text-start">Email</label>
                                        <div className="position-relative">
                                            <FaEnvelope style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#666666', zIndex: 2 }} />
                                            <input
                                                className="w-100"
                                                style={{ paddingLeft: '48px' }}
                                                id="email"
                                                type="email"
                                                name="email"
                                                value={inputField?.email}
                                                placeholder="Enter Email Id"
                                                autoComplete="off"
                                                onChange={handleChange}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        validateForm(e);
                                                    }
                                                }}
                                            />
                                        </div>
                                        {errField?.emailerr !== "" && (<span className="d-flex text-danger signin-error mt-1">{errField?.emailerr}</span>)}
                                    </div>
                                )}
                                {/* Gender */}
                                {partnerSettings?.gender !== 0 && (
                                    <>

                                        <div className="text-start position-relative pb-3">
                                            <label className="d-block partnerLabel pb-2">Gender:</label>
                                            <label className="me-3 partnerLabel">
                                                <input
                                                    type="radio"
                                                    name="gender"
                                                    value="male"
                                                    checked={inputField.gender === "male"} // Bind state for checked
                                                    onChange={handleGenderChange} // Attach handler
                                                />
                                                Male
                                            </label>
                                            <label className="me-3 partnerLabel">
                                                <input
                                                    type="radio"
                                                    name="gender"
                                                    value="female"
                                                    checked={inputField.gender === "female"} // Bind state for checked
                                                    onChange={handleGenderChange} // Attach handler
                                                />
                                                Female
                                            </label>
                                            <label className="partnerLabel">
                                                <input
                                                    type="radio"
                                                    name="gender"
                                                    value="others"
                                                    checked={inputField.gender === "others"} // Bind state for checked
                                                    onChange={handleGenderChange} // Attach handler
                                                />
                                                Others
                                            </label>
                                        </div>

                                    </>
                                )}

                                <div>
                                    {/* Mobile Number */}
                                    {partnerSettings?.mobile !== 0 && (
                                        <div className="mb-4">
                                            <label className="input-label text-start">Mobile Number</label>
                                            <PhoneInput
                                                country={"in"}
                                                value={phoneNumber}
                                                onChange={handleOnChange}
                                                inputStyle={{ width: "100%" }}
                                                placeholder="Enter your phone number"
                                                inputProps={{
                                                    onKeyPress: (e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            validateForm(e);
                                                        }
                                                    }
                                                }}
                                            />
                                            {errField?.mobileerror !== "" && (
                                                <span className="d-flex text-danger signin-error mt-1">{errField?.mobileerror}</span>
                                            )}
                                        </div>
                                    )}
                                </div>


                                <div>
                                    {partnerSettings?.country !== 0 ?
                                        <div className="mb-3">
                                            <CountrySelect
                                                onChange={(country) => {
                                                    setSelectedCountry(country);
                                                    setSelectedState(null);
                                                    setSelectedCity(null);
                                                    setCountryid(country.id);
                                                    handleWorld('country', country.name)
                                                }}
                                                value={selectedCountry}
                                                placeHolder="Select Country"
                                                inputClassName="bg-transparent theme-text-color border-0 country-input"
                                                containerClassName="custom-country mt-3"
                                            />
                                            {errField?.countryerr !== "" && (
                                                <span className="d-flex text-danger signin-error mt-1">{errField?.countryerr}</span>
                                            )}
                                        </div> : ""}

                                    {partnerSettings?.state !== 0 && selectedCountry ?
                                        <div className="mb-3">
                                            <StateSelect
                                                countryid={countryid}
                                                onChange={(state) => {
                                                    setSelectedState(state);
                                                    setSelectedCity(null);
                                                    setstateid(state.id);
                                                    handleWorld('state', state.name)
                                                }}
                                                value={selectedState}
                                                placeHolder="Select State"
                                                inputClassName="bg-transparent theme-text-color border-0 country-input"
                                                containerClassName="custom-country mt-3"
                                            />
                                            {errField?.stateerr !== "" && (
                                                <span className="d-flex text-danger signin-error mt-1">{errField?.stateerr}</span>
                                            )}
                                        </div> : ""}

                                    {partnerSettings?.city !== 0 && selectedState ?
                                        <div className="mb-3">
                                            <CitySelect
                                                countryid={countryid}
                                                stateid={stateid}
                                                onChange={(city) => {
                                                    setSelectedCity(city);
                                                    setCityid(city.id);
                                                    handleWorld('city', city.name)
                                                }}
                                                value={selectedCity}
                                                placeHolder="Select City"
                                                inputClassName="bg-transparent theme-text-color border-0 country-input"
                                                containerClassName="custom-country mt-3"
                                            />
                                            {errField?.cityerr !== "" && (
                                                <span className="d-flex text-danger signin-error mt-1">{errField?.cityerr}</span>
                                            )}
                                        </div> : ""}
                                    {/* {partnerSettings?.state !== 0 ? <StateSelect
                                        countryid={countryid}
                                        onChange={(e) => {
                                            setstateid(e.id);
                                            handleWorld('state', e.name)
                                        }}
                                        placeHolder="Select State"
                                        inputClassName="bg-transparent theme-text-color border-0 country-input"
                                        containerClassName="custom-country mt-3"
                                    /> : ""}
                                    {partnerSettings?.city !== 0 ? <CitySelect
                                        countryid={countryid}
                                        stateid={stateid}
                                        onChange={(e) => {
                                            setCityid(e.id)
                                            handleWorld('city', e.name)
                                        }}
                                        placeHolder="Select City"
                                        inputClassName="bg-transparent theme-text-color border-0 country-input"
                                        containerClassName="custom-country mt-3"
                                    /> : ""} */}
                                </div>
                                {/* Password */}
                                {partnerSettings?.password !== 0 && (
                                    <div className="mb-4">
                                        <label className="input-label text-start">Password</label>
                                        <div className="position-relative">
                                            <FaLock style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#666666', zIndex: 2 }} />
                                            <input
                                                id="password"
                                                type={passwordType}
                                                name="password"
                                                value={inputField?.password}
                                                onChange={handleChange}
                                                autoComplete="off"
                                                className="w-100"
                                                style={{ paddingLeft: '48px', paddingRight: '48px' }}
                                                placeholder='Enter your Password'
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        validateForm(e);
                                                    }
                                                }}
                                            />
                                            <button onClick={togglePassword} type="button" className="eyeButton" style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 2 }}>
                                                {passwordType === "password" ?
                                                    <VscEyeClosed style={{ width: "20px", height: "20px", color: '#666666' }} /> :
                                                    <RxEyeOpen style={{ width: "20px", height: "20px", color: '#666666' }} />}
                                            </button>
                                        </div>
                                        {errField?.passworderr !== "" && (
                                            <span className="d-flex text-danger signin-error mt-1">{errField?.passworderr}</span>
                                        )}
                                    </div>
                                )}
                                {/* Confirm Password */}
                                {partnerSettings?.password_confirm !== 0 && (
                                    <div className="mb-4">
                                        <label className="input-label text-start">Confirm Password</label>
                                        <div className="position-relative">
                                            <FaLock style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#666666', zIndex: 2 }} />
                                            <input
                                                id="password_confirm"
                                                type={confirmPasswordType}
                                                name="password_confirm"
                                                value={inputField?.password_confirm}
                                                onChange={handleChange}
                                                autoComplete="off"
                                                className="w-100"
                                                style={{ paddingLeft: '48px', paddingRight: '48px' }}
                                                placeholder='Enter your confirm Password'
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        validateForm(e);
                                                    }
                                                }}
                                            />
                                            <button onClick={toggleConfirmPassword} type="button" className="eyeButton" style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 2 }}>
                                                {confirmPasswordType === "password" ?
                                                    <VscEyeClosed style={{ width: "20px", height: "20px", color: '#666666' }} /> :
                                                    <RxEyeOpen style={{ width: "20px", height: "20px", color: '#666666' }} />}
                                            </button>
                                        </div>
                                        {errField?.password_confirmerror !== "" && (
                                            <span className="d-flex text-danger signin-error mt-1">{errField?.password_confirmerror}</span>
                                        )}
                                    </div>
                                )}
                                <div>
                                    <div className="mb-3 mb-sm-0 col-12 position-relative">
                                        <ButtonWithLoader loading={loading} text="Sign Up" type={"submit"} className='update-button btn btn w-100 button' />
                                    </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-start flex-wrap-reverse  my-3 ">
                                    {/* <div className="col-sm-2 col-12 p-0 pe-2 d-flex justify-content-sm-between justify-content-center align-items-center gap-2">
                              <img src={google} alt="google" style={{ width: "39px", height: "40px" }} />
                              <img src={fb} alt="facebook" style={{ width: "43px", height: "43px" }} />
                           </div> */}
                                    <div className="col-5 d-none d-sm-flex  justify-content-center" >
                                        <span className="code"></span>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center mt-1">
                                    <h6 className="accountsign">
                                        Already have an account on partner?{" "}
                                        <Link to="/partner" className="text-decoration-none">
                                            <span> Log In</span>
                                        </Link>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </form>
        </div>
    );
};

export default PartnerSignup;